"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SchemaDisplayItemLabel = void 0;
var get_1 = __importDefault(require("lodash/get"));
var react_1 = __importDefault(require("react"));
var label_1 = require("./label");
var utils_1 = require("./utils");
/**
 * Renders the display name for a given property found within the schema
 * @param props
 */
function SchemaDisplayItemLabel(props) {
    var name = props.name, schema = props.schema, size = props.size, color = props.color;
    var field = (0, get_1.default)(schema, (0, utils_1.getNestedFieldNameSchemaProperty)(name));
    // When there is no type it means it is a hidden field.
    if (!field || !field.inputType)
        return null;
    return react_1.default.createElement(label_1.Label, { name: name, label: (0, utils_1.getFieldLabel)(name, schema) || '', size: size, color: color });
}
exports.SchemaDisplayItemLabel = SchemaDisplayItemLabel;
